// import node module libraries
import React from 'react';
import { useLocation } from 'react-router';
import { isStringEmpty } from '../../utils/objectUtils';

const ScrollToTop = () => {
	const location = useLocation();
	const { pathname, hash } = location;

	React.useEffect(() => {
		if (isStringEmpty(hash)) {
			window.scrollTo(0, 0);
		}
	}, [pathname, hash]);

	return null;
};

export default ScrollToTop;